import React from 'react';
const Context = /*#__PURE__*/React.createContext(null);
export default Context;